/*
 * How a message body is turned into something safe to put on screen.
 *
 * Bodies are stored exactly as they were typed and nothing sanitises them on
 * write, so the conversation view rendering `message.message` through
 * `dangerouslySetInnerHTML` meant anyone in a thread could run script in every
 * other participant's session. Messages are plain text and are now rendered as
 * plain text — React escapes them — with `white-space: pre-wrap` keeping the
 * line breaks the author typed.
 *
 * The only markup that ever legitimately reached the table came from the rich
 * text editor the composer used before it became a textarea: whole-message
 * `<p>` wrappers. Those are stripped here FOR DISPLAY ONLY. Nothing is written
 * back, and no other tag is touched — an unknown tag is shown literally, which
 * is what it is.
 */

/**
 * A stored body as the reader should see it.
 *
 * @param message raw `gcms_messages.body`
 * @returns the text to render
 */
export const toPlainMessageText = (message?: string | null): string => {
  if (!message) return ''

  return message.replaceAll('<p>', '').replaceAll('</p>', '').trim()
}

/**
 * The same text, shortened for a one-line preview in the thread list or the
 * header dropdown.
 *
 * @param message raw `gcms_messages.body`
 * @param max characters to keep before the ellipsis
 */
export const toMessagePreview = (message?: string | null, max = 20): string => {
  const text = toPlainMessageText(message)
  return text.length <= max ? text : `${text.substring(0, max)}...`
}
